var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIpsf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000062875710968566512090000011357736949993833897_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#2C3149;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 9.8,
    width: 40,
    height: 20.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031892192364558921020000005189720021563398785_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031892192364558921020000005189720021563398785_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,20c-4.7-4.5-10.5-8.1-17.2-8c-6.4,0.1-12,3.7-16.5,8c4.6,4.4,10.6,8,17.2,8C26.6,28,32.3,24.2,36.8,20 L36.8,20z M40,20c-6.4,6.6-13.1,10.2-19.7,10.2C13.6,30.2,6.5,26.9,0,20C6.2,13.4,13,9.9,19.6,9.8C26.4,9.6,33.3,13,40,20L40,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,13.8c3.4,0,6.2,2.8,6.2,6.2c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2C13.8,16.6,16.5,13.8,20,13.8z  M20,11.4c4.8,0,8.6,3.8,8.6,8.6c0,4.7-3.9,8.6-8.6,8.6c-4.8,0-8.6-3.8-8.6-8.6C11.4,15.3,15.2,11.4,20,11.4L20,11.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,15.6c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4C15.6,17.6,17.6,15.6,20,15.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.7,16.1c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6C20.1,16.8,20.8,16.1,21.7,16.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpsf);
export default __webpack_public_path__ + "static/media/icon-ipsf.2361dd26ad2110a4aaa21ae2db83abe8.svg";
export { ForwardRef as ReactComponent };